import { useAllVariants, useExperimentVariant } from 'src/utils/experimentNew'
import { Experiments } from '../constants'

type Variant = 'control' | 'treatment'

const EXPERIMENT_KEY = Experiments.HideMembershipBannerLoggedOut

export function useHideMembershipBannerLoggedOutExperiment() {
  const { isLoading } = useAllVariants()
  const { value, enableExposure } = useExperimentVariant<Variant | undefined>(
    EXPERIMENT_KEY,
    undefined,
    { autoExpose: false },
  )

  return {
    variant: value ?? 'control',
    isEnabled: value === 'treatment',
    // Resolved once Amplitude has finished fetching. Gating on SWR loading
    // (not on `value` being defined) handles 'off' / unconfigured experiments
    // where value never becomes defined.
    isResolved: !isLoading,
    enableExposure,
  }
}
